import { checkForConfirmWithdrawParam, checkForResetPassParam } from './homePageLayoutHelper';
export var redirectExceptions = function redirectExceptions() {
  if (checkForConfirmWithdrawParam()) return true;
  if (checkForResetPassParam()) return true;
};